<!-- Creates a layout with a left-positioned sidenav and explicit content. -->
<mat-sidenav-container class="app-container" [ngClass]="{'login': !loginStatus}"  color="primary">
  <app-toolbar *ngIf="loginStatus"></app-toolbar>
  <app-sidebar *ngIf="loginStatus"></app-sidebar>
  <app-back-button class="backBeforeLogin" *ngIf="!loginStatus && !pageIsLogin" (click)="getBack()"></app-back-button>
  <app-spinner></app-spinner>
  <app-progress-bar></app-progress-bar>
  <app-content [loginStatus]="loginStatus"></app-content>
</mat-sidenav-container>
